import PageContent from "../components/pageContent";

const NotImplementedPage = () => {
  return (
    <PageContent>
      <>
        <h2
          style={{
            textAlign: "center",
            padding: "50px",
            fontWeight: "bold",
            textShadow: "2px 1px #ffd0d0",
          }}
        >
          Omlouváme se, ale tato funkce není aktuálně implementována
        </h2>
      </>
    </PageContent>
  );
};

export default NotImplementedPage;
